import { AxiosInstance } from "axios";

export const create = async (
  instance: AxiosInstance,
  props: { contractorNo: string; data: any }
) => {
  const path = `/contractors/${props.contractorNo}/optx`;
  return await instance.post(path, props.data);
};
